import * as Cookies from "js-cookie";
import {io} from "socket.io-client";
import crypto from 'crypto';

require('dotenv').config();
const algorithm = 'aes-256-ctr';
const secretKey = 'vOVH6sdmpNWjRRCCVc7rdxs01lwHzfr3';
const iv = crypto.randomBytes(16);

var MenusDATA       = "";
var MenuTREE        = "";
var MenuRoleTREE    = "";


class Helper {

    onEncriptCaptca = (text) => {
        const cipher = crypto.createCipheriv(algorithm, secretKey, iv);
        const encrypted = Buffer.concat([cipher.update(text), cipher.final()]);
        return {
            iv: iv.toString('hex'),
            content: encrypted.toString('hex')
        };
    }

    onDecriptCaptca = (text) => {
        const decipher = crypto.createDecipheriv(algorithm, secretKey, Buffer.from(text.iv, 'hex'));
        const decrpyted = Buffer.concat([decipher.update(Buffer.from(text.content, 'hex')), decipher.final()]);
        return decrpyted.toString();
    }

    URL_API=()=>{
        return process.env.REACT_APP_URL_API;
    }

    URL_API_SERVER=()=>{
        return process.env.REACT_APP_URL_MASTER;
    }

    SET_COOKIES=(keys,values)=>{
        Cookies.remove(keys);
        Cookies.set(keys, values,{});
    }

    GET_COOKIES=(keys)=>{
        const sessionCookie = Cookies.get(keys);
        if (sessionCookie === undefined) {
            return false;
        }else{
            return sessionCookie;
        }
    }

    DEL_COOKIES=(keys)=>{
        const sessionCookie = Cookies.get(keys);
        if (sessionCookie === undefined) {
            return false;
        }else{
            Cookies.remove(keys); 
            return true;   
        }
    }

    
    SIGN_OUT = (callback) => {
        this.DEL_COOKIES('login_portal');
        callback();
    }

    GENERATE_PULUHAN = (nominal) => {
        var	number_string = nominal.toString(),
            separator = "",
            split	= number_string.split('.'),
            sisa 	= split[0].length % 3,
            rupiah 	= split[0].substr(0, sisa),
            ribuan 	= split[0].substr(sisa).match(/\d{1,3}/gi);
            
        if (ribuan) {
            separator = sisa ? ',' : '';
            rupiah += separator + ribuan.join(',');
        }
        rupiah = split[1] != undefined ? rupiah + '.' + split[1] : rupiah;

        return rupiah;
    }

    CURRENT_TIME_MILIS = () => {
        var d = new Date();
        return d.getTime();
    }

    GET_DATE_DIGIPOS = () => {
        var today = new Date();
        var todays = today.setMonth(today.getMonth() - 1);
        var DateNew = new Date(todays);
        var Periode = DateNew.getFullYear() + '-' + ('0' + (DateNew.getMonth() + 1)).slice(-2);
        return Periode;
    }

    CONVERT_CURRENTTIMES = (current) => {
        var d = new Date(current);
        return d.getFullYear() + "-"+ ('0' + (d.getMonth() + 1)).slice(-2)+"-"+d.getDate()+" "+d.getHours() + ":" + d.getMinutes() + ":" + d.getSeconds();
    }

    ON_SEND_MESSAGE_NOTIF = (message) => {
        var isLogin = JSON.parse(this.GET_COOKIES('login_portal'));
        var socket = io(this.URL_API_SERVER(), {
            path: "/notification",
            query: "token=" + isLogin.token_notif
        });
        socket.emit('notification_app', message);
    }

    ON_RAND_CODE = (length) => {
        var result = '';
        var characters = 'ABCDEFGHIJKLMNPQRSTUVWXYZ123456789';
        var charactersLength = characters.length;
        for (var i = 0; i < length; i++) {
          result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    }
    
    CHECk_PING  = (callback) => {
        var isLogin = JSON.parse(this.GET_COOKIES('login_portal'));
        fetch(mHelper.URL_API() + "/profile/ping", {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                "Authorization": "Bearer " + isLogin.token
            },
            body:JSON.stringify({})
        })
        .then((response) => response.json())
        .then((responseJson) => {
            callback(responseJson);
        })
        .catch((error) => {
            console.error(error);
        });
    }

}

const mHelper = new Helper();
export default mHelper;
